import React, { useState } from "react";
import validator from 'validator'
import OkIcon from "../assets/images/ok.svg";
import HomeIcon from "../assets/images/moca-home.svg";
import OkTopLeftIcon from "../assets/images/ok_1.svg";
import OkBottomRightIcon from "../assets/images/ok_2.svg";

function ContactForm() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [emailError, setEmailError] = useState('')
  
  let handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData();    

    try {
      formData.append('emailAddress', email)

      let res = await fetch("https://api.dev.notifi.network/privatehooks/kb7m1bwwxp", {
        method: "POST",
        body: formData
      })

      if (validator.isEmail(email)) {
        setEmailError('')
        console.log(setEmailError);
        if (res.status === 200) {
          setEmail("");
          setIsSuccess(true);
        } else {
          setMessage("There was an issue submitting your email address, please try again.");
        }

      } else {
        setEmailError('Please enter a valid email address')
      }

    } catch (err) {
      console.log(err);
    }

  };

  return (
    <form onSubmit={handleSubmit} className="signupform">
      {
      !isSuccess ? (
        <>
        <h2>Sign Up for Updates</h2>
          <div className="form-fields">
          <label for="emailAddress">Email Address</label>
          <input
            type="text"
            value={email}
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <div className="emailError">{emailError && <span>{emailError}</span>}</div>
          </div>
          <div className="form-fields">
          <input type="submit" value="Submit" className="btn"/>
          </div>

          <div className="message">{message && <p>{message}</p>}</div>
          <div className="legal">
          By clicking Submit, I agree to receive updates and news from Mocaverse and Animoca Brands via Notifi, and I accept the <a href="https://notifi.network/privacy" target="_blank" rel="noopener noreferrer">privacy policy</a> and <a a href="https://notifi.network/terms" target="_blank" rel="noopener noreferrer">terms of use</a>.
          </div>
        </>
        ) : (
            <div>

              <div className="message success">
                <img class="success-checkbox" src={OkIcon} alt="Ok"></img>
              
                <p>THANK YOU FOR SIGNING UP</p>
                
                <img src={HomeIcon} alt="Moca"></img>
              </div>
     

              <div className="close-btn-modal"></div>
              
            <img
              src={OkTopLeftIcon}
              alt="close"
              className="success-top-left-modal"
            />
                         
              <img
              src={OkBottomRightIcon}
              alt="close"
              className="success-bottom-right-modal"
            />

            </div>
          ) 
    }
      </form>
    );
}

  export default ContactForm;
